import { GetServerSidePropsContext } from 'next/types';
import type { IncomingMessage } from 'http';

import { parse, serialize } from 'cookie';

import { logger } from '../logger';

export const cleanCookies = (req: GetServerSidePropsContext['req'] | IncomingMessage) => {
  if (req.headers.cookie) {
    try {
      const cookies = parse(req.headers.cookie);

      // 파싱 결과가 비어있으면 원본 유지
      if (Object.keys(cookies).length === 0) {
        // NOTE: 쿠키 원문은 PII(토큰/세션 등) 가능성이 있어 절대 로그로 남기지 않는다.
        logger.warn('[cleanCookies] Parse returned empty object. Keep original cookie header.');
        return;
      }

      const items = Object.keys(cookies)
        .map((key) => {
          const value = cookies[key];
          if (value === undefined) {
            logger.warn(`[cleanCookies] Undefined value for key: ${key}`);
            return null;
          }
          return serialize(key, value);
        })
        .filter((v): v is string => v !== null);

      // 결과가 비어있으면 원본 유지
      if (items.length === 0) {
        logger.warn(
          '[cleanCookies] All cookies lost after processing. Keep original cookie header.',
        );
        return;
      }

      req.headers.cookie = items.join('; ');
    } catch (error) {
      logger.error(`[cleanCookies] Error processing cookies: ${String(error)}`);
      // 에러 발생 시 원본 쿠키 유지
    }
  }
};
